export function QObjGrouping() {
  this.fMatchValue = null;
  this.fRootObj = null;
  this.fMultiRec = false;
  this.fGroup = [];
}
